import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { DEFAULT_CONTENT, mergeContent } from "./defaults";

const ContentContext = createContext({ content: DEFAULT_CONTENT, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/site/content");
      setContent(mergeContent(res.data || {}));
    } catch {
      setContent(DEFAULT_CONTENT);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ content, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
